import { isEmpty } from "lodash";

const getCustomerListResponse = (data) => {
    if (isEmpty(data)) return [];

    const mappingData = data?.data?.map((item) => {
        return {
            id: item?.customer_id,
            name: item?.name,
        };
    });

    return mappingData;
};

export default getCustomerListResponse;
